import isNumeric from 'validator/es/lib/isNumeric';
import { ValidationError } from '../errors/ValidationError';
import { validateString } from './validateString';

export function validateNumericString(
	name: string,
	value: string | number | undefined,
	minLength?: number,
	maxLength = 100,
	required = true,
): string | undefined {
	const normalized = validateString(name, value?.toString(), minLength, maxLength, required);

	// If not required, undefined is OK
	if (normalized === undefined) {
		return undefined;
	}

	// Make sure it's a numeric value and exactly 10 digits
	if (!isNumeric(normalized)) {
		throw new ValidationError(`Invalid value: ${name} must be numeric`);
	}

	return normalized;
}
